
import { defineComponent } from "vue";
import KeycloakService from "@/services/keycloak/keycloakService";
export default defineComponent({
  name: "LandingView",
  data() {
    return {
      howToWorks: [
        {
          icon: require("../../assets/images/schedule.svg"),
          title: this.$t("landingPage.howToWorks1.title") as string,
          content: this.$t("landingPage.howToWorks1.content") as string,
        },
        {
          icon: require("../../assets/images/money.svg") as string,
          title: this.$t("landingPage.howToWorks2.title") as string,
          content: this.$t("landingPage.howToWorks2.content") as string,
        },
        {
          icon: require("../../assets/images/mac_icon.svg") as string,
          title: this.$t("landingPage.howToWorks3.title") as string,
          content: this.$t("landingPage.howToWorks3.content") as string,
        },
      ] as any,
      userInfo: {} as any,
    };
  },
  methods: {
    login() {
      return KeycloakService.CallLogin("/redirect");
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo") as string);
  },
});
